export const API_CODE_SUCCESS = 200;
